module.exports = __webpack_public_path__ + "static/img/ent-detail-27.ecfd767.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-27.jpg
// module id = 8r2Z
// module chunks = 52